import AdSlotManagement from './AdSlotManagement';

export default AdSlotManagement;
